import { useQuery } from "@tanstack/react-query"
import { capabilityExecutionsAnalyticsQuery } from "../lib/capabilityExecutionsAnalyticsQuery"

export function useCapabilityExecutionsAnalyticsQuery(
  ...args: Parameters<typeof capabilityExecutionsAnalyticsQuery>
) {
  return useQuery(capabilityExecutionsAnalyticsQuery(...args))
}
